import './setupBrowserPolyfills'; // Carrega os polyfills necessários
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Importar bibliotecas para o PDF
import 'jspdf';
import 'jspdf-autotable';

// ==========================================
// BB-130-CB - DISPONIBILIZAR SERVIÇOS GLOBALMENTE PARA TESTE
// ==========================================

// Importar serviços para disponibilizar globalmente
import socketService from './services/socketService';
import speechService from './services/speechService';

// Disponibilizar serviços no objeto window para acesso via console
window.socketService = socketService;
window.speechService = speechService;

// Adicionar função de debug expandido ao window
window.debugVocalizacao = () => {
  console.log('🔍 ===== DEBUG DO SISTEMA DE VOCALIZAÇÃO =====');
  
  // Status dos serviços
  console.log('📊 Status dos Serviços:');
  console.log('  - socketService disponível:', typeof window.socketService);
  console.log('  - speechService disponível:', typeof window.speechService);
  console.log('  - WebSocket conectado:', socketService.isConnected());
  console.log('  - Vocalização autorizada:', speechService.autorizado);
  
  // Status da fila de vocalização
  const filaStatus = speechService.getFilaStatus();
  console.log('📋 Status da Fila de Vocalização:');
  console.log('  - Tamanho da fila:', filaStatus.tamanhoFila);
  console.log('  - Vocalizando atualmente:', filaStatus.vocalizandoAtualmente);
  console.log('  - Estado atual:', filaStatus.estadoAtual);
  
  // Status do WebSocket
  console.log('🔌 Status do WebSocket:');
  const socketStatus = socketService.getStatus();
  console.log('  - Conectado:', socketStatus.connected);
  console.log('  - Tentativas de reconexão:', socketStatus.reconnectAttempts);
  console.log('  - Último erro:', socketStatus.lastConnectionError || 'Nenhum');
  
  // Informações de callback (se disponível)
  console.log('🔊 Sistema de Callback:');
  console.log('  - Método notificarVocalizacaoConcluida disponível:', typeof socketService.notificarVocalizacaoConcluida === 'function');
  
  // Vocalização atual (se houver)
  if (speechService.vocalizacaoAtual) {
    console.log('🎵 Vocalização Atual:');
    console.log('  - Senha ID:', speechService.vocalizacaoAtual.senhaId);
    console.log('  - Iniciada em:', new Date(speechService.vocalizacaoAtual.iniciadaEm).toLocaleTimeString());
    console.log('  - Tempo decorrido:', Date.now() - speechService.vocalizacaoAtual.iniciadaEm, 'ms');
  } else {
    console.log('🎵 Nenhuma vocalização em andamento');
  }
  
  console.log('🔍 ===== FIM DO DEBUG =====');
  
  return {
    socketService: {
      available: typeof window.socketService !== 'undefined',
      connected: socketService.isConnected(),
      status: socketService.getStatus()
    },
    speechService: {
      available: typeof window.speechService !== 'undefined',
      authorized: speechService.autorizado,
      filaStatus: speechService.getFilaStatus(),
      vocalizacaoAtual: speechService.vocalizacaoAtual
    },
    callback: {
      methodAvailable: typeof socketService.notificarVocalizacaoConcluida === 'function'
    }
  };
};

console.log('🚀 Serviços disponibilizados globalmente:');
console.log('  - window.socketService');
console.log('  - window.speechService');
console.log('  - window.debugVocalizacao()');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
